import { createSelector } from "reselect";

export const makeSelectAdminUser = createSelector(
  (state) => state.adminUserReducer,
  (users) => users.adminUsers
);
